
  import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

  import TixMessage from '@/components/elements/TixMessage.vue'
  import TixTemplate from '@/components/elements/TixTemplate.vue'
  import FormInput2 from '@/components/forms/FormInput2.vue'
  import { apiErrorMessageOrRethrow } from '@/errors/helpers'
  import { authenticationFields } from '@/helpers/Authentication'
  import EventBus from '@/helpers/EventBus'
  import { reportFormValidity } from '@/helpers/Validation'
  import type { LanguageStrings } from '@/language/types'
  import { loginAndTransferCart } from '@/state/Cart'

  @Component({
    name: 'LoginFlowStepPassword',
    components: { FormInput2, TixTemplate, TixMessage },
  })
  export default class extends Vue {
    @Prop()
    showForgotLink: boolean

    @Emit('goBack')
    goBack() {}

    t: LanguageStrings['loginFlowStepPassword']
    password: string = ''
    submitting: boolean = false
    error: string | null = null

    get field() {
      const [, password] = authenticationFields() ?? []
      return password
    }

    get forgotLink() {
      return {
        label: this.t.forgotPassword,
        to: '/user/forgot-password',
      }
    }

    get email(): string {
      return this.$store.getters['LoginFlow/email']
    }

    dismissModal() {
      EventBus.$emit('tix:modal:dismiss', 'login')
    }

    async onSubmit() {
      this.submitting = true

      try {
        await reportFormValidity(this.$el as HTMLFormElement)

        await loginAndTransferCart({ username: this.email, password: this.password }, 'password')

        EventBus.$emit('tix:login:success')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- login API errors have complex nested structures (response.data.message, validation errors)
      } catch (error: any) {
        if (error.validationError) {
          // Ignore validation errors as the input already component handles it
        } else if (error.response?.status === 401) {
          // Fall through to the server response for `password` authentication. The API returns a specific and friendly message, like;
          //   - "Incorrect password for account"
          //   - "Account not found"
          //
          // This is a known account enumeration vulnerability which we have accepted for
          // password authentication.
          // @see https://affinity-it-security.com/what-is-account-enumeration/
          this.error = error.response.data.message
        } else {
          this.error = apiErrorMessageOrRethrow(error)
        }
      } finally {
        this.$nextTick(() => (this.submitting = false))
      }
    }
  }
